type FileSizeNotation = 'BYTE' | 'KB' | 'MB' | 'GB';

const sizes: FileSizeNotation[] = ['BYTE', 'KB', 'MB', 'GB'];
const oneKb = 1024;

/**
 * Получить формат файла
 * @param {number} size - исходный размер файла, указывается в байтах
 */
export const getFileSizeNotation = (size: number): FileSizeNotation => {
  const i = Math.floor(Math.log(size) / Math.log(oneKb));
  return sizes[i];
};

/**
 * Конвертировать байты в указанный формат
 * @param {number} bytes - Входящее значение, указывается в байтах
 * @param {FileSizeNotation} notation - Формат в который необходимо форматировать
 */
export const convertTo = (bytes: number, notation: FileSizeNotation): string => {
  const i = sizes.findIndex((format) => format === notation);

  const converted = bytes / Math.pow(oneKb, i)

  const rounded = Math.ceil(converted * 100) / 100;
  const decimalPlaces = rounded % 1 === 0 ? 0 : 2;

  return rounded.toFixed(decimalPlaces);
};

/**
 * Получить байты из указанного формата
 * @param {number} sourceSize - Размер который необходимо получить в байтах
 * @param {FileSizeNotation} notation - Формат с которого форматируется
 */
export const getInByte = (sourceSize: number, notation: FileSizeNotation): string => {
  const i = sizes.findIndex((format) => format === notation);

  const bytes = sourceSize * Math.pow(oneKb, i);

  const rounded = Math.ceil(bytes * 100) / 100;
  const decimalPlaces = rounded % 1 === 0 ? 0 : 2;

  return rounded.toFixed(decimalPlaces);
};

/**
 * Получить байты из указанного формата
 * @param {number} sourceSize - Размер который необходимо получить в байтах
 */
export const getInByteInMb = (sourceSize: number): number => {
  return Math.ceil((sourceSize / 1024 / 1024) * 100) / 100;
};
